import { RoleHelpers, useCommonComponentContext } from "@maysoft/common-component-react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { ICodename } from "../../commons/interfaces";
import TenantService, { ITenantGetAllResponse } from "../../services/identity/Tenant.service";

const useTenantCodenames = (initialRequest: { serviceCode?: string; organizationId: string }) => {
    const { userInfo } = useCommonComponentContext();
    const isServiceAdmin = RoleHelpers.isServiceAdmin(userInfo?.userProfile?.roleType);

    const [tenantResponse, setTenantResponse] = useState<ITenantGetAllResponse[]>([]);
    const tenantCodenames: ICodename[] = useMemo(() => {
        return tenantResponse.map((item) => {
            return {
                code: item.tenantCode,
                name: item.name,
            };
        });
    }, [tenantResponse]);
    const [isLoading, setIsLoading] = useState(true);
    const loadTenants = useCallback(async (params?: { serviceCode?: string, organizationId?: string }) => {
        try {
            setIsLoading(true);
            const response = await TenantService.getAll(params);
            setTenantResponse(response);
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    }, []);
    useEffect(() => {
        if (isServiceAdmin) {
            loadTenants({ serviceCode: initialRequest.serviceCode, organizationId: initialRequest.organizationId });
        }
    }, [isServiceAdmin, loadTenants, initialRequest.organizationId, initialRequest.serviceCode])

    return { onLoadTenants: loadTenants, tenantCodenames, isLoading };
}

export default useTenantCodenames;